import axios from "axios";

 const MAIN_URL = "https://trinetskydev.pixonix.tech"
 export const axiosInstance = axios.create({baseURL: MAIN_URL});


 export default MAIN_URL;

